export type IAppFeatureResources = typeof AppFeatureResources;

export const AppFeatureResources = {
    GGCForBusinessButton: "Sprawdzam szczegóły",
};
